export const DEFAULT_HEAP_MASK_OPACITY = 0.3;

const HEAP_MASK_PALETTE = ['#F44336', '#8BC34A', '#9C27B0', '#FF9800', '#3F51B5'];

export interface HeapMaskPreferences {
  visibility: Record<string, boolean>;
  opacity: Record<string, number>;
}

export interface HeapMaskBitmap {
  width: number;
  height: number;
  pixels: Uint8Array;
}

export interface HeapMaskEntry {
  id: string;
  labelKey: string;
  color: string;
  opacity: number;
  enabled: boolean;
}

export interface HeapMaskOverlay {
  id: string;
  bitmap: HeapMaskBitmap;
  color: string;
  opacity: number;
}

// calculate palette index from mask name, so that the same mask always gets the same color
export function resolveHeapMaskColor(maskId: string): string {
  let hash = 0;
  for (let index = 0; index < maskId.length; index++) {
    hash += maskId.charCodeAt(index);
  }
  return HEAP_MASK_PALETTE[hash % HEAP_MASK_PALETTE.length];
}

export function hexToRgb(color: string): [number, number, number] {
  return [parseInt(color.slice(1, 3), 16), parseInt(color.slice(3, 5), 16), parseInt(color.slice(5, 7), 16)];
}
